import React from 'react';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';

/**
 * @component NotFoundPage
 * @description Componente de página 404 cuando la ruta no existe
 * @vibe-color ⚫ #4B5563
 * @vibe-icon ❓
 */
const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <div className="mb-6">
          <h1 className="text-9xl font-bold text-gray-900">404</h1>
          <div className="animate-bounce bg-primary-600 p-2 w-10 h-10 ring-1 ring-primary-600 rounded-full mx-auto mt-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
        
        <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
          Página no encontrada
        </h2>
        <p className="mt-3 text-xl text-gray-600 max-w-md mx-auto">
          Lo sentimos, la página que estás buscando no existe o ha sido movida.
        </p>
        
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <Link 
            to="/" 
            className="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <FiHome className="mr-2" />
            Volver al inicio
          </Link>
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center justify-center px-5 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <FiArrowLeft className="mr-2" />
            Página anterior
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
